import React from 'react'
import { Section } from '@shared/components/section'
import User from '@shared/svg/user.svg'

import styles from './style.module.scss'

export const View = () => (
	<Section className={styles.wrapper}>
		<div className={styles.summary}>
			<h3>Польза</h3>
			<div className={styles.summaryText}>
				Главное — рационально решить финансовую проблему клиента. Поэтому мы всячески стараемся быть
				полезными. Улучшаем сервисы, делаем их удобными и дружелюбными. <br />
				<br /> Иногда выходим за рамки оговоренных обязательств, если знаем, что можем помочь
				человеку.
			</div>
		</div>
		<div className={styles.recommendation}>
			<User className={styles.manIcon} />
			<div className={styles.recommendationText}>
				<h4 className={styles.recommendationTitle}>
					<span className={styles.coloredText}>9 из 10</span>
					<br />
					клиентов рекомендуют <br /> нас своим партнёрам
				</h4>
			</div>
		</div>
	</Section>
)
